module.exports = __webpack_public_path__ + "img/Share.f62776ce.svg";